<template>
  <div class="io-other">
    <div class="io" id="io" ref="io"></div>
    <div class="io-box">
      <div class="date">
        <div>
          <span>min</span>
          <span>max</span>
          <span>mvg</span>
          <span>curant*</span>
        </div>
      </div>
      <div class="date-box">
        <div class="left">
          <span style="background: #00d8ff"></span>
          <span>_read(Mbps)</span>
        </div>
        <div class="right">
          <span>{{ this.needData._read.Min }}Mbps</span>
          <span>{{ this.needData._read.Max }}Mbps</span>
          <span>{{ this.needData._read.Mvg }}Mbps</span>
          <span>{{ this.needData._read.Curant }}Mbps</span>
        </div>
      </div>
      <div class="date-box">
        <div class="left">
          <span style="background: #ffa800"></span>
          <span>_write(Mbps)</span>
        </div>
        <div class="right">
          <span>{{ this.needData._write.Min }}Mbps</span>
          <span>{{ this.needData._write.Max }}Mbps</span>
          <span>{{ this.needData._write.Mvg }}Mbps</span>
          <span>{{ this.needData._write.Curant }}Mbps</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["needData"],
  mounted() {
    // setTimeout(() => {
    //   this.io(this.needData);
    // }, 200);
    this.io(this.needData);
  },
  // watch: {
  //   'needData'() {
  //     this.io(this.needData);
  //   },
  // },
  methods: {
    io(param) {
      let myEchart = this.$echarts.init(document.getElementById("io"));
      var date = [];
      param.DateTime.forEach((item) => {
        date.push(item.substring(item.length - 5));
      });
      // var base = +new Date(2020, 0, 0);
      // var oneDay = 24 * 3600 * 1000;
      // var date = [];

      // var data = [Math.random() * 200];
      // var data2 = [Math.random() * 500];
      // var data3 = [Math.random() * 700];
      // var data4 = [Math.random() * 900];

      // for (var i = 1; i < 367; i++) {
      //   var now = new Date((base += oneDay));
      //   date.push(
      //     [now.getFullYear(), now.getMonth() + 1, now.getDate()].join("/")
      //   );
      //   data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
      //   data2.push(Math.round((Math.random() - 0.5) * 20 + data2[i - 1]));
      //   data3.push(Math.round((Math.random() - 0.5) * 20 + data3[i - 1]));
      //   data4.push(Math.round((Math.random() - 0.5) * 20 + data4[i - 1]));
      // }

      let option = {
        grid: {
          top: "12%",
          left: "8%",
          bottom: "35%",
          right: "5%",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisTick: {
            show: false,
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(Mbps)",
          nameGap: 10,
          nameTextStyle: {
            padding: [0, 40, 0, 0],
          },
          boundaryGap: [0, "100%"],
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "2020预算",
            type: "line",
            smooth: true,
            stack: "",
            symbol: "none",
            sampling: "average",

            itemStyle: {
              color: "#CA76C4",
              normal: {
                color: "#ffa800",
                lineStyle: {
                  color: "#ffa800",
                  width: 1,
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(255,168,0,0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255,168,0,0.9)",
                    },
                  ]),
                },
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: "red",
                  },
                },
              },
            },
            data: param.Data1,
          },
          {
            name: "2019预算",
            type: "line",
            smooth: true,
            symbol: "none",
            sampling: "average",
            itemStyle: {
              color: "#CA76C4",
              normal: {
                color: "#01d4fa",
                lineStyle: {
                  color: "#01d4fa",
                  width: 1,
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(1,212,250,0.3)",
                    },
                    {
                      offset: 1,
                      color: "rgba(1,212,250,0.9)",
                    },
                  ]),
                },
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: "red",
                  },
                },
              },
            },
            data: param.Data2,
          },
        ],
      };
      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.io-other {
  width: 100%;
  height: 100%;
  position: relative;
}
.io {
  width: 100%;
  height: 100%;
}

.io-box {
  width: 95%;
  height: 7.4vh;
  position: absolute;
  bottom: 0;
  left: 3%;
}
.io-box .date {
  width: 100%;
  height: 1.6vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #00e4ff;
  font-size: 0.6vw;
}

.io-box .date div {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.io-box .date div span {
  height: 100%;
  margin-right: .8vw;
  /* transform: scale(0.9); */
  line-height: 1vh;
}

.io-box .date-box {
  width: 100%;
  height: 2.3vh;
  background: url("../../assets/img/74.png");
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.6vw;
  margin-bottom: 0.5vh;
}

.io-box .date-box .left {
  width: 16%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.6vw;
  justify-content: space-between;
  margin-left: 1vw;
}

.io-box .date-box .left span:nth-child(1) {
  width: 1.45vw;
  height: 0.7vh;
  background: red;
}
.io-box .date-box .left span:nth-child(2) {
  color: #aebfc4;
}

.io-box .date-box .right {
  width: 39%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #aebfc4;
  margin-right: 2.5vw;
}

.io-box .date-box .right span {
  margin-left: .5vw;
}
.io-box .date-box .right span:nth-child(1) {
   margin-left: 0;
}
</style>


